const stringToNumber = (v) => Number(v.replace(/[^0-9.-]/g, ''));

class ProductQuickAdd extends HTMLElement {
  constructor() {
    super();
    let variantData = JSON.parse(this.getAttribute("data-variants"));
    let variantSelect = this.querySelector(".pr_variants");

    // quick add widget variant select changes, ie. 1 pack to 3 pack, show / hide the matching subscription option input
    // update selected-variant variable on product-quick-add element & update pricing shown to user
    variantSelect.addEventListener("change", (e) => {
      let variant = variantData.find(
        (variant) => variant.id === parseInt(e.target.value)
      );
      if(this.querySelector('selling-plan-widget') != null){
        this.updateQuickAddWidget(variant);
      } else {
        this.updateOneTimeProduct(variant)
        this.updateFeaturedImage(variant.featured_image);
      }

       if(this.querySelector('.product-information') != null){
        this.querySelector('.product-price-wrapper .product-price').textContent = variant.price;
        if(this.querySelector('.product-price-wrapper .compare-price') != null) {
          this.querySelector('.product-price-wrapper .compare-price').textContent = variant?.compare_price;
        }
      }

    });
  }

  updateOneTimeProduct(variant) {
    let cardDetails = document?.querySelector(`[details-for="${variant.product_id}"]`)
    let srikeThrough = cardDetails.querySelector('.price s.pr_price')
    let salePrice = cardDetails.querySelector('.price .reg_price')

    if(srikeThrough){
      srikeThrough.textContent = `${
        variant.compare_price != null
          ? variant.compare_price.replace("AUD", "")
          : variant.price.replace("AUD", "")
        }`;

      if(variant?.compare_price > variant?.price){
        srikeThrough?.classList?.remove('hidden_txt')
      } else {
        srikeThrough?.classList?.add('hidden_txt')
      }
    }

    if(salePrice){
      salePrice.textContent = `${
        variant.price != null
          ? variant.price.replace("AUD", "")
          : variant.price.replace("AUD", "")
        }`;
    }

  }

  updateQuickAddWidget(variant) {
    let subscriptionOption = this.querySelector(".purchase-option.subscription");
    let oneTimeOption = this.querySelector(".purchase-option.one-time");
    this.updateOptionPrices(subscriptionOption, variant);
    // this.updateOptionPrices(oneTimeOption, variant);
    this.querySelector("selling-plan-widget").setAttribute(
      "data-variantselected",
      variant.id
    );

    let firstSellingPlanOpt = (this.querySelector(`[data-sellingplansfor='${variant.id}']`).value !== "" ? this.querySelector(`[data-sellingplansfor='${variant.id}']`).value : this.querySelector(`[data-sellingplansfor='${variant.id}']`)[0].value)

    // if(this.querySelector(`[name="selling_plan"]`).value !== ''){
    if(this.querySelector(`[data-sellingplansfor='${variant.id}']`).value !== ""){
      this.querySelector(`[name="selling_plan"]`).value = firstSellingPlanOpt
      if(!this.getAttribute('data-featuredProduct')){
        let subOptLabel = this.querySelector(".purchase-option.subscription .purchase-option--label")
        let region = document.querySelector('body').getAttribute("data-market-handle");
        if(region == "au") {
          subOptLabel.textContent = "Free Shipping";
        } else {
          subOptLabel.textContent = "Subscribe & Save";
        }
      }
    } else {
      // console.log("One time previously selected")
      this.querySelector(".purchase-option.subscription .purchase-option--label").textContent = "One-Time";
      this.querySelector(`[name="selling_plan"]`).value = ""
    }
    
    if(variant.featured_image != null){
      let isModal = this.classList.contains('modal')
      this.updateFeaturedImage(variant.featured_image, isModal);
    }
  }

  updateFeaturedImage(image, isModal) {
    
    let target = !isModal ? this.parentElement.children[0].querySelector(".grid_img") : this.querySelector('.modal_details img');

    let img = new Image();
    img.fetchPriority = "high";
    img.loading = "eager";
    img.src = `${image}?width=${
      target.clientWidth * 2
    }`;
    img.onload = () => {
      !isModal ?
      target.style.backgroundImage = `url(${image}?width=${
        target.clientWidth *
        2
      })` : 
      target.src = `${image}?width=${
        target.clientWidth *
        2
      })`
      ;
    };
  }

  updateOptionPrices(option, variant) {
    let selectInput = this.querySelector(`[data-sellingplansfor="${variant.id}"]`)
    let varComparePrice = $(selectInput).find('option:selected')[0].getAttribute("data-optioncompareprice")
    let varSalePrice = $(selectInput).find('option:selected')[0].getAttribute("data-optionprice")
    option.querySelector(".purchase-option--compare-price").textContent = `${
      varComparePrice != null && (stringToNumber(varComparePrice) > stringToNumber(varSalePrice))
        ? varComparePrice.replace("AUD", "")
        : ""
    }`;
    
    option.querySelector(".purchase-option--price").textContent = `${
      varSalePrice != null
        ? varSalePrice.replace("AUD", "")
        : variant.price.replace("AUD", "")
    }`;
  }
}

customElements.define("product-quick-add", ProductQuickAdd);

class SellingPlanWidget extends HTMLElement {
  constructor() {
    super();

    let sellingPlanInput = this.querySelector('[name="selling_plan"]');
    let subscriptionLabel = this.querySelector(
      ".purchase-option.subscription .purchase-option--label"
    );

    if(this.getAttribute('data-oneTimeToggle') != null){
      let radioInputs = this.querySelectorAll('input[type="radio"][name="purchaseOption"]')        
      let subOption = this.querySelector('input[type="radio"][name="purchaseOption"][value="subscription"]')
      
      radioInputs.forEach(radio => {
        radio.addEventListener('change', (e) => {
          if(e.target.value == 'one_time'){
            sellingPlanInput.value = ""
          } else {
            const variantId = this.getAttribute('data-variantselected');
            const match = this.querySelector(`[data-sellingplansfor="${variantId}"]`);
            if (match) sellingPlanInput.value = match.value;
          }
        });
      });

      this.querySelector('select').addEventListener('mousedown', e => {
        if (subOption && !subOption.checked) {
          subOption.checked = true;
          subOption.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });

    }

    const region = this.getAttribute("data-country");

    // Selling plan input changes, ie. 2 month to 5 month or one-time, update widget text & product-form selling plan input
    let sellingPlanInputs = this.querySelectorAll(
      ".subscription-options-container select"
    );
    sellingPlanInputs.forEach((select) => {
      select.addEventListener("change", (e) => {
        sellingPlanInput.value = e.target.value;
        let selectedComparePrice = $(select).find('option:selected')[0].getAttribute('data-optioncompareprice')
        let comparePriceLabel = this.querySelector('.purchase-option--compare-price')
    
        let salePriceLabel = this.querySelector('.purchase-option--price')
        let selectedSalePrice = $(select).find('option:selected')[0].getAttribute('data-optionprice')

        if(selectedComparePrice != null && (stringToNumber(selectedComparePrice) > stringToNumber(selectedSalePrice))){
          comparePriceLabel.innerHTML = selectedComparePrice
        } else {
          comparePriceLabel.innerHTML = ""
        }
        
        salePriceLabel.innerHTML = selectedSalePrice

        if (e.target.value === "") {
          subscriptionLabel.textContent = "One-Time";
          // sellingPlanInputs.forEach((select) => {
          //   $(select).val("").trigger("change");
          // });
        } else {
          if(!this.getAttribute('data-featuredProduct')){
            if(region == "AU") {
              subscriptionLabel.textContent = "Free Shipping";
            } else {
              subscriptionLabel.textContent = "Subscribe & Save";
            }
          }
        }
      });
    });
  }
}

customElements.define("selling-plan-widget", SellingPlanWidget);



class ModalClose extends HTMLElement {
    connectedCallback() {
    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
  }

  handleClick = () => {
    document.querySelector('.quickAddModal').click();
  }
}
customElements.define("modal-close", ModalClose);

window.addEventListener('productFormSubmit', ({ detail }) => {
  if (detail.status === 'complete' && document.querySelector('.quickAddModal') != null) {
    document.querySelector('.quickAddModal').click()
  }
});